export const reportsList = {
  general: [
    {
      id: "contracts",
      label: "Contracts",
      fileFormats: [
        { id: "xls", label: "XLSX" },
        // { id: "pdf", label: "PDF" },
      ],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "itemstock",
      label: "Item Stock",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "myhistory",
      label: "My History",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: true,
      dateFilter: true,
    },
    {
      id: "staffhistory",
      label: "Staff History",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: true,
      dateFilter: true,
    },
    {
      id: "staffsizes",
      label: "Staff Sizes",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "pricelist",
      label: "Price List",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "outstandingorders",
      label: "Outstanding Orders",
      fileFormats: [
        { id: "xls", label: "XLSX" },
        { id: "pdf", label: "PDF" },
      ],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "itemreturn",
      label: "Returns",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "stafflist",
      label: "Staff List",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "entitlement",
      label: "Entitlement",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "overentitlement",
      label: "Over Entitlement",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: false,
      dateFilter: false,
    },
    {
      id: "underentitlement",
      label: "Under Entitlement",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: true,
      typeFilter: false,
      dateFilter: false,
    },
  ],
  financial: [
    {
      id: "statement",
      label: "Statement",
      fileFormats: [
        { id: "xls", label: "XLSX" },
        { id: "pdf", label: "PDF" },
      ],
      branchFilter: false,
      typeFilter: false,
      dateFilter: true,
    },
    {
      id: "invoicelines",
      label: "Invoice Lines",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: true,
    },
    {
      id: "invoicelinesbyref",
      label: "Invoice Lines By Reference",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: true,
    },
    {
      id: "invoicelinesbybranch",
      label: "Invoice Lines By Branch",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: true,
    },
    {
      id: "invoicelinesbycontract",
      label: "Invoice Lines By Contract",
      fileFormats: [{ id: "xls", label: "XLSX" }],
      branchFilter: false,
      typeFilter: false,
      dateFilter: true,
    },
  ],
};
